import PropTypes from 'prop-types';
import React from 'react';

const ValidationError = ({
  errorMsg, fieldName,
}) => (
  <label htmlFor={fieldName}
    className="control-label-validation">
    {errorMsg}
  </label>
);

ValidationError.propTypes = {
  errorMsg: PropTypes.string,
  fieldName: PropTypes.string,
};

export default ValidationError;



// WEBPACK FOOTER //
// ./src/components/common/ValidationError.js